import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { leaveConflicts } from "../../api/payroll";

// Tells the approver who else from the branch is already away on the same days.
export const LeaveConflictWarning = ({ requestId }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    leaveConflicts(requestId).then(setData).catch(() => setData(null));
  }, [requestId]);

  if (!data || !data.conflicts.length) return null;

  return (
    <div
      data-testid={`leave-conflict-${requestId}`}
      className="mt-3 rounded-2xl bg-amber-500/10 p-3 text-xs font-bold text-amber-500"
    >
      <p className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        {t("conflicts.title", { count: data.conflicts.length })}
      </p>
      <ul className="mt-2 grid gap-1 font-mono text-[11px] font-semibold">
        {data.conflicts.slice(0, 4).map((c, i) => (
          <li key={`${c.user_id}-${i}`} data-testid="leave-conflict-row">
            {c.name} · {c.start_date} → {c.end_date} · {t("conflicts.sharedDays", { count: c.shared_days })}
          </li>
        ))}
      </ul>
      {data.team_size ? (
        <p className="mt-2 text-[11px] text-amber-500/90" data-testid={`leave-conflict-ratio-${requestId}`}>
          {t("conflicts.coverage", { away: data.away_together, team: data.team_size })}
        </p>
      ) : null}
    </div>
  );
};
